import { CancelTokenSource } from 'axios'
import AnonymousAgent from '../api/AnonymousAgent'

class ChoiceService {
  getEntry = async (source?: CancelTokenSource) => {
    return AnonymousAgent.Choices.getEntry(source)
  }

  getNextSelectionByChoice = async (id: number, source?: CancelTokenSource) => {
    return AnonymousAgent.Choices.getNextSelectionByChoice(id, source)
  }

  getPreviousSelectionByChoice = async (
    id: number,
    source?: CancelTokenSource
  ) => {
    return AnonymousAgent.Choices.getPreviousSelectionByChoice(id, source)
  }
}

export default new ChoiceService()
